<script lang="ts">
    import { onDestroy } from 'svelte';

    export let name: string;
    export let errors: Record<string, string[]>;
    export let label: string = '';
    export let checked: boolean = false;
    export let disabled: boolean = false;
    export let required: boolean = false;

    errors[name] = [];

    const validate = (val: boolean = checked) => {
        errors[name] = [];
        if (required && !val) {
            errors[name].push('This field is required');
        }
    };
    validate();

    const handleChange = (e: Event) => {
        checked = (e.currentTarget as HTMLInputElement).checked;
        validate(checked);
    };

    onDestroy(() => { errors[name] = []; });
</script>

<div class="checkbox-wrapper">
    <label class="check-label">
        <input
            type="checkbox"
            {name}
            {disabled}
            {required}
            bind:checked
            on:change={handleChange}
            class:error={errors[name].length > 0}
            on:blur
        />
        <span>{label}</span>
    </label>
</div>

<style lang="scss">
    .checkbox-wrapper {
        display: inline-flex;
        flex-direction: column;
        vertical-align: top;
    }
</style>
